import {remCalc} from '_themeUtils'

const sizeSelector = {
    SizeSelector: {
        baseStyle: () => ({
            sizesRowWrapper: {
                w: '100%',
                // Mobile (Figma): show ~3 size rows then scroll (row ≈ 50px with 16px padding → cap ≈ 150px).
                maxH: {base: remCalc(150), md: 'auto'},
                alignItems: 'flex-start',
                pt: {base: 'spacing.none', md: 'spacing.4'},
                pb: {base: 'spacing.none', md: 'spacing.8'},
                overflowY: {base: 'auto', md: 'unset'},
            },
            sizesRow: {
                w: '100%',
                flexDirection: {base: 'column', md: 'row'},
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                columnGap: {base: 'spacing.none', md: 'spacing.4'},
                rowGap: {base: 'spacing.none', md: 'spacing.1'},
            },
            sizeLabelWrapper: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: {base: 'space-between', md: 'center'},
                w: {base: '100%', md: 'auto'},
                minW: remCalc(30),
                // Mobile: FIXED 50px row height (not just min) so exactly ~3 rows fit the 150px scroll
                // cap regardless of whether the colour section is present. Desktop keeps auto height.
                h: {base: remCalc(50), md: 'auto'},
                minH: {base: remCalc(50), md: remCalc(30)},
                flexShrink: {base: 0, md: 'unset'},
                boxSizing: 'border-box',
                textStyle: {base: 'paragraphSm', md: 'paragraphXs'},
                // Mobile (Figma): size number = paragraph-sm Light, tracking 0.7px.
                // Desktop keeps the existing pill look (tracking 3, weight 400).
                letterSpacing: {base: remCalc(0.7), md: remCalc(3)},
                fontWeight: {base: 350, md: 400},
                // Mobile (Figma "Size slot"): 10px horizontal padding, bottom divider (row height is fixed).
                p: {base: remCalc(0), md: 'spacing.1'},
                px: {base: remCalc(10), md: 'spacing.1'},
                py: {base: remCalc(0), md: 'spacing.1'},
                cursor: 'pointer',
                // Keep a 1px solid border on all breakpoints (avoids the `border:none` shorthand
                // resetting border-color). On mobile only the bottom edge is visible (divider);
                // the other edges are transparent.
                border: '1px solid',
                borderColor: 'color.border.transparent',
                borderBottomColor: {base: 'color.border.grey.400', md: 'color.border.transparent'},
                borderTopColor: 'color.border.transparent',
                trasition: 'all 0.3s ease',
                _hover: {
                    borderColor: {md: 'color.border.black'},
                },
            },
            sizeLabelOutOfStockWrapper: {
                _hover: {
                    borderColor: 'color.border.transparent',
                },
            },
            selectedSizeLabelWrapper: {
                // Desktop: full box outline (border-color). Mobile: the row has no box border
                // (only a bottom divider), which we darken to mark the selection.
                borderColor: 'color.border.black',
                borderTopColor: 'color.border.black',
                borderBottomColor: 'color.border.black',
            },
            sizeLabel: {
                my: 'spacing.none',
                pl: {base: 'spacing.none', md: 'spacing.none'},
            },
            sizeLabelOutOfStock: {
                color: 'color.text.grey.600',
                textDecoration: 'line-through',
                cursor: 'not-allowed',
            },
            // Figma: right-side size info = paragraph-xs (12/14), tracking 0.6px, #262626.
            // "Richiedi il prodotto" is underlined; "Solo uno disponibile" is not.
            labelStockInfo: {
                textStyle: 'paragraphXs',
                letterSpacing: remCalc(0.6),
                color: 'color.text.black',
                textDecoration: 'underline',
            },
            labelOnlyOneInfo: {
                textStyle: 'paragraphXs',
                letterSpacing: remCalc(0.6),
                color: 'color.text.black',
                textDecoration: 'none',
            },
            selectionTitle: {
                textStyle: 'paragraphMd',
                fontWeight: 400,
                letterSpacing: remCalc(0.6),
                mb: 'spacing.5',
            },
            selectionTitleError: {
                color: 'color.text.error',
            },
        }),
        variants: {
            wishlist: {
                sizesRowWrapper: {
                    maxH: 'unset',
                    overflowY: 'hidden',
                    pt: {base: 0, xl: 'spacing.4'},
                    pb: 'spacing.8',
                },
                sizesRow: {
                    flexDir: 'row',
                    rowGap: 'spacing.1',
                    columnGap: 'spacing.4',
                },
                sizeLabelWrapper: {
                    justifyContent: 'center',
                    w: 'auto',
                    textStyle: 'paragraphXs',
                    borderTopColor: 'color.border.transparent',
                },
                sizeLabel: {
                    my: 'spacing.none',
                    pl: 'spacing.none',
                },
            },
        },
    },
}

export default sizeSelector
